// @flow

export type NETWORK_CONNECTED_TYPE = {
  type: 'NETWORK_CONNECTED',
};
export const NETWORK_CONNECTED = 'NETWORK_CONNECTED';

export type NETWORK_DISCONNECTED_TYPE = {
  type: 'NETWORK_DISCONNECTED',
};
export const NETWORK_DISCONNECTED = 'NETWORK_DISCONNECTED';


export type NETWORK_ACTION_TYPE =
  | NETWORK_CONNECTED_TYPE
  | NETWORK_DISCONNECTED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/network.js